<script setup lang="ts">
import type { ICryptoCompanyServices } from '~/components/entity/crypto-company'
import { cryptoCompanyServices } from '~/components/widget/crypto-company/services/mocks'

const { services } = defineProps<{ services: ICryptoCompanyServices }>()

const enabledServices = Object.keys(services)
  .filter((key) => services[key])
  .map((i) => {
    return {
      text: cryptoCompanyServices.find((option) => option.name === i)?.text,
      icon: i
    }
  })
</script>

<template>
  <div class="grid grid-cols-1 gap-5 md:grid-cols-3">
    <div
      v-for="item in enabledServices"
      :key="item.icon"
      class="flex items-center gap-2 rounded-md bg-gray-100 p-4"
    >
      <div class="rounded-md bg-white p-2"><UiIcon :name="item.icon" /></div>
      <div class="text-sm">
        {{ $t(item.text) }}
      </div>
    </div>
  </div>
</template>
